export function getCdnImageWithPath(path: string, name: string = 'svg') {
  return `https://assets.godefi.me${path}/${name}`
}

export function getCdnUrl(path: string) {
  return `https://assets.godefi.me/${path}`
}
